import { render } from "./SecondFieldset.vue?vue&type=template&id=a7f7ac76"
import script from "./SecondFieldset.vue?vue&type=script&lang=js"
export * from "./SecondFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/Users/timvanhalewyck/Sites/d9multisite/web/sites/bdmyshopi.be/modules/custom/konnu_prijscalculator/prijscalculator-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__